import { Controller } from '@stimulus/core'

export default class SuggestionController extends Controller {
  static targets = ["title", "description"]
  static values = {
    target: String
  }

  public select(event: Event) {
    const radio = event.target as HTMLInputElement
    const value = radio.value
    const target = radio.dataset.target

    if (target === 'permanent_offer_title') {
      const dutchTitleField = document.querySelector<HTMLInputElement>('input[id*="permanent_offer_title_nl"]')
      if (dutchTitleField) {
        dutchTitleField.value = value
      }
    } else if (target === 'permanent_offer_description') {
      const dutchDescField = document.querySelector<HTMLTextAreaElement>('textarea[id*="permanent_offer_description_nl"]')
      if (dutchDescField) {
        dutchDescField.value = value
      }
    }
  }
} 